import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import en from '../../i18n/en.i18n.json';
import ja from '../../i18n/ja.i18n.json';
import msMy from '../../i18n/ms-MY.i18n.json';
import ta from '../../i18n/ta.i18n.json';
import th from '../../i18n/th.i18n.json';
import zhCn from '../../i18n/zh-CN.i18n.json';
import zhTw from '../../i18n/zh-TW.i18n.json';

const resources = {
  en: {
    home: en,
  },
  ja: {
    home: ja,
  },
  'ms-MY': {
    home: msMy,
  },
  ta: {
    home: ta,
  },
  th: {
    home: th,
  },
  'zh-CN': {
    home: zhCn,
  },
  'zh-TW': {
    home: zhTw,
  },
};

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    ns: ['home'],
    defaultNS: 'home',
    // backend : { loadPath : '/i18n/__lng__.i18n.json' },
    keySeparator: '::',
    nsSeparator: '$$',
    // Set it to false if your backend loads resources sync
    initImmediate: true,
    interpolation: {
      // not needed for react as it escapes by default
      escapeValue: false,
      prefix: '__',
      suffix: '__',
    },
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
    },
  });

export default i18n;
